var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDaSolid = function SvgDaSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#340AAB",
    fillRule: "evenodd",
    d: "M21 11c0 5.523-4.477 10-10 10S1 16.523 1 11 5.477 1 11 1s10 4.477 10 10M7.662 8.25h1.09c1.502 0 2.646 1.194 2.646 2.75s-1.144 2.75-2.647 2.75H6.416v-5.5zm0 4.29h1.09c.856 0 1.447-.597 1.447-1.54s-.591-1.54-1.448-1.54h-1.09zm8.837 1.21h-1.362l-.249-.864h-1.915l-.25.864h-1.361l1.774-5.5h1.589zm-2.568-4.125-.608 2.082h1.215z",
    clipRule: "evenodd"
  })));
};
export default SvgDaSolid;